import { GraphSystems, PeakStatus, TestGraph } from "../types";
import { INBAR_12_ENDPOINT } from "./endpoints";
import { fetcher } from "./utils";

export const getInbar12GraphsData = async ({
    testId,
    systemId,
    historicTestsToShow,
}: {
    testId: string;
    systemId?: GraphSystems;
    historicTestsToShow: number[];
}) => {
    let params = { test_id: testId } as {
        test_id: string;
        system_id?: GraphSystems;
        previous_test_ids?: number[];
    };
    if (systemId !== undefined) {
        params = { ...params, system_id: systemId };
    }

    if (historicTestsToShow.length) {
        params = {
            ...params,
            previous_test_ids: historicTestsToShow,
        };
    }

    const data = await fetcher(INBAR_12_ENDPOINT, {
        params,
    });

    const { error } = data;
    if (error) {
        console.error(error);
        throw new Error(error);
    }
    return data as TestGraph[];
};

export type Inbar12GraphUpdate = Pick<
    TestGraph,
    | "peak1_status"
    | "peak2_status"
    | "peak3_status"
    | "response1_status"
    | "response2_status"
    | "slope_calculation_begin_value"
    | "slope_calculation_end_value"
    | "vat_value"
    | "rcp_value"
> & {
    testId?: string;
    graph_id: string;
    response3_status?: PeakStatus;
    slope1_status?: PeakStatus;
    slope2_status?: PeakStatus;
    slope3_status?: PeakStatus;
};

export const updateInbar12Graph = async (data: Inbar12GraphUpdate) => {
    if (!data.testId) {
        throw new Error("Test ID is required");
    }
    const resData = await fetcher(INBAR_12_ENDPOINT, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
        },
        params: {
            test_id: data.testId,
            graph_id: data.graph_id,
        },
        body: JSON.stringify(data),
    });

    const { error } = resData;
    if (error) {
        console.error(error);
        throw new Error(error);
    }
    return resData as TestGraph;
};
